module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@yxl/open-app/~/axios/index.js
// module id = hazw
// module chunks = 2 4 7